import { Pipe, PipeTransform } from '@angular/core';
import { Address, AddressFormatterService, SearchResultObj } from '@yourcause/common';

@Pipe({
    name: 'gcSearchNppAddress',
    standalone: false
})
export class SearchNppAddressPipe implements PipeTransform {
  constructor (
    public formatter: AddressFormatterService
  ) { }

  transform (document: SearchResultObj): string {
    return this.formatter.format(
      this.getAddressToUse(document),
      true
    );
  }

  getAddressToUse (document: SearchResultObj): Address {
      return {
        address1: document.address1,
        address2: document.address2,
        city: document.city,
        stateProvRegCode: document.stateProvRegCode,
        country: document.country,
        postalCode: document.postalCode
      };
  }
}
